import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=a6f67dca&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=a6f67dca&prod&scoped=true&lang=less"
import style1 from "./ContactUs.vue?vue&type=style&index=1&id=a6f67dca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f67dca",
  null
  
)

export default component.exports